import React from 'react'
import { Container, Button, Carousel } from 'react-bootstrap';
import hero1 from '../assest/images/hero.jpg';
import hero2 from '../assest/images/hero8.jpg';
import hero3 from'../assest/images/hero3.jpg';
import hero4 from'../assest/images/hero7.jpg';
import '../hero.css';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";


//end of import
function Herosection() {
 
  return (
     <div className="hero-section text-center text-white">
  <Carousel fade interval={5000} controls={false} indicators>
        <Carousel.Item>
          <div className="hero-slide" style={{ backgroundImage: `url(${hero1})` }}>
            <div className="overlay">
              <Container>
                <h1>Escapio Travels</h1>
                <p>Your dream vacation starts here</p>
                <motion.div
    initial={{ scale: 0.9, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 0.6 }}
  >
    <Link to="/contact">
      <Button className="button" size="lg">
        Start your journey
      </Button>
    </Link>
  </motion.div>
</Container>
            </div>
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="hero-slide" style={{ backgroundImage: `url(${hero2})` }}>
            <div className="overlay">
              <Container>
  <motion.h1
    initial={{ y: 30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8 }}
  >
    Discover Sri Lanka’s Hidden Gems
  </motion.h1>

  <motion.p
    initial={{ y: 20, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 0.3, duration: 0.8 }}
  >
    Plan your perfect holiday with us
  </motion.p>

  <motion.div
    initial={{ scale: 0.9, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 0.6 }}
  >
    <Link to="/packages">
      <Button className="button" size="lg">
        View Packages
      </Button>
    </Link>
  </motion.div>
</Container>
            </div>
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="hero-slide" style={{ backgroundImage: `url(${hero3})` }}>
            <div className="overlay">
              <Container>
                <h1>Adventure Awaits</h1>
                <p>Let us guide you to paradise</p>
                <Link to="/contact">
                  <Button
                  
                    variant="primary"className="button"
                    size="lg"
                    onClick={() =>
                    window.open(
                        "https://mail.google.com/mail/?view=cm&fs=1&to=info@escapiotravels.com&su=Inquiry%20about%20Escapio%20Travels&body=Hello,%20I%20would%20like%20to%20know%20more%20about%20your%20travel%20packages.",
                        "_blank"
                      )
                    }
                  >
                    Email Us
                  </Button>
                  
                </Link>
              </Container>
            </div>
          </div>
        </Carousel.Item>

                <Carousel.Item>
          <div className="hero-slide" style={{ backgroundImage: `url(${hero4})` }}>
            <div className="overlay">
              <Container>
                <h1>From Beaches to Peaks, We Take You There</h1>
                <p>Pure Island Magic</p>

              </Container>
            </div>
          </div>
        </Carousel.Item>

      
      </Carousel>
   
        
</div>

    
  )
}

export default Herosection
